window.DealTypes ?= {}

DealTypes.Model = require './models/deal_type'
DealTypes.View = require './views/deal_type'

DealTypes.init = ({dealTypes, consumerId, csrf, rootUrl}, done) ->
  return done() unless consumerId?.length > 0 and dealTypes?.length > 0

  $ ->
    for {id, value, el} in dealTypes
      model = new DealTypes.Model {id, value, consumerId, csrf, rootUrl}
      new DealTypes.View {el, model}

    done()


module.exports = DealTypes
